<template>
  <main class="kb-page">
    <header class="kb-hero">
      <div>
        <button class="back" @click="$router.push('/AdminAgentes/' + agenteId)">
          ← Voltar ao agente
        </button>
        <span>Base de Conhecimento</span>
        <h1>{{ val(agente, "nome") || "Agente" }}</h1>
        <p>
          Organize conteúdos que serão preparados para consulta pelos agentes.
        </p>
      </div>
      <button class="hero-add" @click="novaFonte"><i class="mdi mdi-plus"></i> Adicionar fonte</button>
    </header>

    <aside class="help-strip">
      <i class="mdi mdi-information-outline"></i>
      <div><b>Como funciona</b><p>Crie uma fonte para organizar o conteúdo do agente. “API” significa uma API externa cujos dados serão importados e indexados; a chave técnica do n8n permanece protegida no servidor.</p></div>
    </aside>

    <section class="metrics">
      <article>
        <small>Fontes</small><b>{{ val(indicadores, "fontes") }}</b>
      </article>
      <article>
        <small>FAQs</small><b>{{ val(indicadores, "faqs") }}</b>
      </article>
      <article>
        <small>Documentos</small><b>{{ val(indicadores, "arquivos") }}</b>
      </article>
      <article>
        <small>APIs</small><b>{{ val(indicadores, "apis") }}</b>
      </article>
      <article class="warn">
        <small>Pendentes</small><b>{{ val(indicadores, "pendentes") }}</b>
      </article>
      <article :class="{ danger: val(indicadores, 'erros') }">
        <small>Com erro</small><b>{{ val(indicadores, "erros") }}</b>
      </article>
    </section>

    <section v-if="!selecionada" class="source-area">
      <div class="toolbar">
        <div>
          <h2>Fontes do agente</h2>
          <p>FAQs, documentos e APIs indexáveis.</p>
        </div>
        <div>
          <input
            v-model="busca"
            placeholder="Pesquisar fonte"
            @keyup.enter="carregarFontes"
          /><select v-model="tipoFiltro" @change="carregarFontes">
            <option value="">Todos os tipos</option>
            <option>FAQ</option>
            <option>ARQUIVO</option>
            <option>API</option>
          </select>
        </div>
      </div>
      <div v-if="carregando" class="empty">Carregando...</div>
      <div v-else-if="!fontes.length" class="empty">
        <i class="mdi mdi-book-open-page-variant-outline"></i>
        <h3>Nenhuma fonte cadastrada</h3>
        <p>Escolha qual conteúdo deseja disponibilizar para este agente.</p>
        <button class="primary empty-add" @click="novaFonte">Adicionar fonte</button>
      </div>
      <div v-else class="source-grid">
        <article v-for="f in fontes" :key="val(f, 'id')" class="source-card">
          <div class="source-head">
            <i :class="icone(val(f, 'tipo'))"></i
            ><span :class="['pill', String(val(f, 'status')).toLowerCase()]">{{
              statusLabel(val(f, "status"))
            }}</span>
          </div>
          <small
            >{{ val(f, "tipo") }} ·
            {{ modoLabel(val(f, "modoSincronizacao")) }}</small
          >
          <h3>{{ val(f, "nome") }}</h3>
          <p>{{ val(f, "descricao") || "Sem descrição." }}</p>
          <div class="source-info">
            <span
              ><b>{{ val(f, "quantidadeItens") }}</b> itens</span
            ><span>{{ data(val(f, "ultimaSincronizacaoEm")) }}</span>
          </div>
          <footer>
            <button @click="abrirFonte(f)">Abrir</button
            ><button @click="editarFonte(f)">Editar</button
            ><button v-if="val(f, 'modoSincronizacao') === 'MANUAL'" @click="sincronizar(f)">Sincronizar</button
            ><button @click="alternarFonte(f)">
              {{ val(f, "ativo") ? "Desativar" : "Ativar" }}
            </button>
          </footer>
        </article>
      </div>
    </section>

    <section v-else class="detail-area">
      <div class="detail-title">
        <button class="back" @click="fecharFonte">← Todas as fontes</button>
        <div>
          <span>{{ val(selecionada, "tipo") }}</span>
          <h2>{{ val(selecionada, "nome") }}</h2>
          <p>{{ val(selecionada, "descricao") }}</p>
        </div>
        <button v-if="val(selecionada, 'modoSincronizacao') === 'MANUAL'" class="primary" :disabled="fonteInativa" @click="sincronizar(selecionada)">
          Solicitar sincronização
        </button>
      </div>
      <aside v-if="fonteInativa" class="inactive-warning">
        <i class="mdi mdi-lock-outline"></i>
        Esta fonte está desativada. O conteúdo pode ser consultado, mas alterações e reprocessamentos estão bloqueados até a reativação.
      </aside>
      <nav class="tabs">
        <button
          :class="{ active: aba === 'conteudo' }"
          @click="
            aba = 'conteudo';
            carregarConteudo();
          "
        >
          Conteúdo</button
        ><button
          :class="{ active: aba === 'historico' }"
          @click="
            aba = 'historico';
            carregarHistorico();
          "
        >
          Histórico
        </button>
      </nav>

      <div v-if="aba === 'historico'" class="panel">
        <div class="panel-head">
          <div>
            <h3>Histórico de sincronizações</h3>
            <p>Acompanhamento dos processamentos desta fonte.</p>
          </div>
        </div>
        <div v-if="!historico.length" class="empty small">
          Nenhuma sincronização registrada.
        </div>
        <div v-else class="timeline">
          <article v-for="h in historico" :key="val(h, 'id')">
            <i></i>
            <div>
              <b>{{ tipoSync(val(h, "tipo")) }}</b
              ><span
                :class="['pill', String(val(h, 'status')).toLowerCase()]"
                >{{ statusLabel(val(h, "status")) }}</span
              >
              <p>
                {{ data(val(h, "iniciadaEm")) }} ·
                {{ val(h, "itensLidos") }} lidos ·
                {{ val(h, "itensAtualizados") }} atualizados ·
                {{ val(h, "itensComErro") }} erros ·
                {{ val(h, "chunksGerados") }} chunks
              </p>
              <em>{{ val(h, "mensagem") }}</em>
            </div>
          </article>
        </div>
      </div>

      <div v-else-if="val(selecionada, 'tipo') === 'FAQ'" class="panel">
        <div class="panel-head">
          <div>
            <h3>Perguntas e respostas</h3>
            <p>Alterações de conteúdo voltam automaticamente para pendente.</p>
          </div>
          <button class="primary" :disabled="fonteInativa" @click="novaFaq">+ Nova FAQ</button>
        </div>
        <div class="filters">
          <input
            v-model="buscaItem"
            placeholder="Pesquisar pergunta, resposta ou palavra-chave"
            @keyup.enter="carregarFaqs"
          /><button @click="carregarFaqs">Pesquisar</button
          ><button class="secondary" :disabled="fonteInativa || !selecionados.length" @click="faqLote(true)">
            Reindexar selecionadas
          </button
          ><button class="danger" :disabled="fonteInativa || !selecionados.length" @click="desativarFaqsSelecionadas">
            Desativar selecionadas
          </button>
        </div>
        <div v-if="!faqs.length" class="empty small">
          Nenhuma FAQ nesta fonte.
        </div>
        <div v-else class="faq-list">
          <article v-for="q in faqs" :key="val(q, 'id')">
            <input
              type="checkbox"
              :value="val(q, 'id')"
              v-model="selecionados"
            />
            <div>
              <small>{{ val(q, "categoria") || "Sem categoria" }}</small>
              <h4>{{ val(q, "pergunta") }}</h4>
              <p>{{ val(q, "resposta") }}</p>
              <em>{{ val(q, "palavrasChave") }}</em>
            </div>
            <span
              :class="['pill', String(val(q, 'statusIndexacao')).toLowerCase()]"
              >{{ statusLabel(val(q, "statusIndexacao")) }}</span
            ><div class="item-actions">
              <button class="secondary" :disabled="fonteInativa" @click="editarFaq(q)">Editar</button>
              <button
                :class="val(q, 'ativo') ? 'danger' : 'success'"
                :disabled="fonteInativa"
                @click="alternarFaq(q)"
              >
                {{ val(q, "ativo") ? "Desativar" : "Reativar" }}
              </button>
            </div>
          </article>
        </div>
      </div>

      <div v-else-if="val(selecionada, 'tipo') === 'ARQUIVO'" class="panel">
        <div class="panel-head">
          <div>
            <h3>Documentos</h3>
            <p>Envie uma vez ou reutilize um documento da biblioteca.</p>
          </div>
          <div>
            <label :class="['upload', 'primary', { disabled: fonteInativa }]"
              >Enviar documento<input
                :disabled="fonteInativa"
                type="file"
                accept=".pdf,.doc,.docx,.txt,.csv,.json,.xls,.xlsx"
                @change="upload" /></label
            ><button :disabled="fonteInativa" @click="abrirBiblioteca">Usar existente</button>
          </div>
        </div>
        <div v-if="!arquivos.length" class="empty small">
          Nenhum documento vinculado.
        </div>
        <div v-else class="file-grid">
          <article v-for="a in arquivos" :key="val(a, 'id')">
            <i class="mdi mdi-file-document-outline"></i>
            <div>
              <h4>{{ val(a, "titulo") || val(a, "nomeOriginal") }}</h4>
              <p>
                {{ val(a, "nomeOriginal") }} ·
                {{ tamanho(val(a, "tamanhoBytes")) }}
              </p>
              <span
                :class="[
                  'pill',
                  String(val(a, 'statusProcessamento')).toLowerCase(),
                ]"
                >{{ statusLabel(val(a, "statusProcessamento")) }}</span
              >
              <button
                v-if="val(a, 'statusProcessamento') === 'ERRO'"
                type="button"
                class="error-detail-link"
                @click="abrirErroArquivo(a)"
              >Ver detalhes do erro</button>
            </div>
            <a
              :href="
                '/Process/AdminAgentes/Conhecimento/Arquivos/' +
                val(a, 'id') +
                '/Download'
              "
              target="_blank"
              >Baixar</a
            ><button :disabled="fonteInativa" @click="reprocessar(a)">Reprocessar</button
            ><button class="danger" :disabled="fonteInativa" @click="excluirArquivo(a)">Excluir</button>
          </article>
        </div>
      </div>

      <div v-else class="panel api-panel">
        <div class="panel-head">
          <div>
            <h3>API indexável</h3>
            <p>
              Dados consultados e armazenados para indexação, não para tempo
              real.
            </p>
          </div>
        </div>
        <form class="api-form" @submit.prevent="salvarApi">
          <label>Nome<input v-model="api.nome" required /></label
          ><label
            >Método<select v-model="api.metodo">
              <option>GET</option>
              <option>POST</option>
            </select></label
          ><label class="wide"
            >URL<input
              v-model="api.url"
              type="url"
              required
              placeholder="https://api.exemplo.com/dados" /></label
          ><label
            >Tipo de autenticação<select v-model="api.tipoAutenticacao">
              <option value="NENHUMA">Nenhuma</option>
              <option value="API_KEY">API Key no header</option>
              <option value="BEARER">Bearer Token</option>
            </select></label
          ><label v-if="api.tipoAutenticacao !== 'NENHUMA'"
            >{{ api.tipoAutenticacao === "BEARER" ? "Bearer token" : "Header e API Key" }}<input
              v-model="api.credencialReferencia"
              :placeholder="api.tipoAutenticacao === 'BEARER' ? 'token' : 'X-API-Key:valor'" /></label
          ><label
            >Campo identificador<input
              v-model="api.campoIdentificador"
              placeholder="id" /></label
          ><label
            >Campo título<input
              v-model="api.campoTitulo"
              placeholder="nome" /></label
          ><label
            >Campo conteúdo<input
              v-model="api.campoConteudo"
              placeholder="descricao" /></label
          ><label
            >Campo atualização<input
              v-model="api.campoDataAtualizacao"
              placeholder="updated_at"
          /></label>
          <details class="wide">
            <summary>Configuração avançada JSON</summary>
            <label
              >Headers JSON<textarea
                v-model="api.headersJson"
              ></textarea></label
            ><label
              >Parâmetros JSON<textarea
                v-model="api.parametrosJson"
              ></textarea></label
            ><label
              >Body JSON<textarea v-model="api.bodyJson"></textarea>
            </label>
          </details>
          <div class="actions wide">
            <button
              type="button"
              @click="testarApi"
              :disabled="fonteInativa || !val(api, 'id')"
            >
              Testar conexão</button
            ><button class="primary" :disabled="fonteInativa">Salvar configuração</button>
            <button type="button" class="danger" @click="excluirFonteApi">Excluir API</button>
          </div>
        </form>
        <div v-if="testeApi" class="test-result">
          <b>{{
            testeApi.dependeN8n
              ? "Teste pelo n8n"
              : testeApi.sucesso
              ? "Conexão realizada"
              : "A API respondeu com erro"
          }}</b>
          <p>{{ testeApi.mensagem || "HTTP " + testeApi.status }}</p>
          <pre v-if="testeApi.resumo">{{ testeApi.resumo }}</pre>
        </div>
        <div v-if="apiItens.length" class="api-items">
          <h3>Itens importados</h3>
          <article v-for="i in apiItens" :key="val(i, 'id')">
            <div>
              <b>{{ val(i, "titulo") || val(i, "identificadorExterno") }}</b>
              <p>{{ val(i, "conteudoResumo") }}</p>
            </div>
            <span
              :class="['pill', String(val(i, 'statusIndexacao')).toLowerCase()]"
              >{{ statusLabel(val(i, "statusIndexacao")) }}</span
            >
          </article>
        </div>
      </div>
    </section>

    <div v-if="modalFonte" class="modal">
      <form @submit.prevent="salvarFonte">
        <header>
          <div>
            <small>Base de Conhecimento</small>
            <h2>{{ fonte.id ? "Editar fonte" : "Nova fonte" }}</h2>
          </div>
          <button type="button" @click="modalFonte = false">×</button>
        </header>
        <label>Nome<input v-model="fonte.nome" required /></label
        ><label
          >Tipo<select v-model="fonte.tipo" required :disabled="fonte.id">
            <option disabled value="">Selecione</option>
            <option>FAQ</option>
            <option>ARQUIVO</option>
            <option>API</option>
          </select></label
        ><label
          >Sincronização<select v-model="fonte.modoSincronizacao" :disabled="fonte.tipo === 'API'">
            <option>MANUAL</option>
            <option v-if="fonte.tipo !== 'API'">EVENTO</option>
          </select></label
        ><label class="wide"
          >Descrição<textarea v-model="fonte.descricao"></textarea>
        </label>
        <footer>
          <button type="button" @click="modalFonte = false">Cancelar</button
          ><button class="primary">Salvar fonte</button>
        </footer>
      </form>
    </div>
    <div v-if="modalFaq" class="modal">
      <form @submit.prevent="salvarFaq">
        <header>
          <div>
            <small>Fonte FAQ</small>
            <h2>{{ faq.id ? "Editar FAQ" : "Nova FAQ" }}</h2>
          </div>
          <button type="button" @click="modalFaq = false">×</button>
        </header>
        <label class="wide"
          >Pergunta<textarea v-model="faq.pergunta" required></textarea></label
        ><label class="wide"
          >Resposta<textarea
            v-model="faq.resposta"
            rows="6"
            required
          ></textarea></label
        ><label>Categoria<input v-model="faq.categoria" /></label
        ><label
          >Palavras-chave<input
            v-model="faq.palavrasChave"
            placeholder="entrega, prazo, pedido"
        /></label
        ><label class="wide"
          >Ação recomendada<select v-model="faq.acaoRecomendada">
            <option value="NENHUMA">Nenhuma</option>
            <option value="SUGERIR_REUNIAO">Sugerir reunião</option>
            <option value="TRANSFERIR_HUMANO">Transferir para humano</option>
            <option value="SOLICITAR_DADOS">Solicitar dados</option>
          </select></label
        >
        <footer>
          <button type="button" @click="modalFaq = false">Cancelar</button
          ><button class="primary">Salvar FAQ</button>
        </footer>
      </form>
    </div>
    <div
      v-if="modalBiblioteca"
      class="modal"
    >
      <div class="library">
        <header>
          <div>
            <small>Documentos compartilhados</small>
            <h2>Biblioteca</h2>
          </div>
          <button @click="modalBiblioteca = false">×</button>
        </header>
        <input
          v-model="buscaBiblioteca"
          placeholder="Pesquisar documento"
          @keyup.enter="carregarBiblioteca"
        />
        <article v-for="a in biblioteca" :key="val(a, 'id')">
          <i class="mdi mdi-file-outline"></i>
          <div>
            <b>{{ val(a, "nomeOriginal") }}</b>
            <p>
              {{ tamanho(val(a, "tamanhoBytes")) }} · usado em
              {{ val(a, "vinculos") }} fonte(s)
            </p>
          </div>
          <button class="primary" @click="vincular(a)">
            Usar neste agente
          </button>
        </article>
        <div v-if="!biblioteca.length" class="empty small">
          Nenhum documento disponível.
        </div>
      </div>
    </div>

    <div v-if="modalErroArquivo" class="modal">
      <section class="error-dialog" role="dialog" aria-modal="true" aria-labelledby="erro-arquivo-titulo">
        <header>
          <div>
            <small>FALHA NO PROCESSAMENTO</small>
            <h2 id="erro-arquivo-titulo">Detalhes do erro</h2>
          </div>
          <button type="button" aria-label="Fechar" @click="modalErroArquivo = false">×</button>
        </header>
        <h3>{{ val(arquivoComErro, "titulo") || val(arquivoComErro, "nomeOriginal") }}</h3>
        <div class="error-message">
          {{ val(arquivoComErro, "ultimaMensagemErro") || "O processamento falhou, mas não foi registrada uma mensagem detalhada." }}
        </div>
        <dl>
          <div><dt>Tentativas</dt><dd>{{ val(arquivoComErro, "tentativas") || 0 }}</dd></div>
          <div><dt>Última tentativa</dt><dd>{{ data(val(arquivoComErro, "ultimaTentativaEm")) }}</dd></div>
        </dl>
        <p class="error-guidance">Corrija a causa indicada e clique em <strong>Reprocessar</strong> para tentar novamente.</p>
        <footer>
          <button type="button" @click="modalErroArquivo = false">Fechar</button>
          <button type="button" class="primary" :disabled="fonteInativa" @click="reprocessarErroArquivo">Reprocessar agora</button>
        </footer>
      </section>
    </div>
  </main>
</template>

<script>
import axios from "axios";
export default {
  name: "ConhecimentoView",
  data: () => ({
    agenteId: 0,
    agente: {},
    indicadores: {},
    fontes: [],
    selecionada: null,
    aba: "conteudo",
    busca: "",
    tipoFiltro: "",
    carregando: false,
    modalFonte: false,
    fonte: {},
    faqs: [],
    faq: {},
    modalFaq: false,
    selecionados: [],
    buscaItem: "",
    arquivos: [],
    biblioteca: [],
    modalBiblioteca: false,
    modalErroArquivo: false,
    arquivoComErro: null,
    buscaBiblioteca: "",
    api: { metodo: "GET", tipoAutenticacao: "NENHUMA", ativo: true },
    apiItens: [],
    testeApi: null,
    historico: [],
  }),
  mounted() {
    this.agenteId = Number(this.$route.params.id);
    this.carregar();
  },
  computed: {
    fonteInativa() {
      return !!this.selecionada && !this.val(this.selecionada, "ativo");
    },
  },
  methods: {
    val(o, k) {
      if (!o) return null;
      return o[k] !== undefined ? o[k] : o[k[0].toUpperCase() + k.slice(1)];
    },
    async carregar() {
      const r = await axios.get(
        `/Process/AdminAgentes/Conhecimento/Agentes/${this.agenteId}/Resumo`
      );
      this.agente = this.val(r.data, "agente") || {};
      this.indicadores = this.val(r.data, "indicadores") || {};
      await this.carregarFontes();
    },
    async carregarFontes() {
      this.carregando = true;
      try {
        const q = new URLSearchParams({ pagina: 1, tamanhoPagina: 50 });
        if (this.busca) q.set("busca", this.busca);
        if (this.tipoFiltro) q.set("tipo", this.tipoFiltro);
        const r = await axios.get(
          `/Process/AdminAgentes/Conhecimento/Agentes/${this.agenteId}/Fontes?${q}`
        );
        this.fontes = this.val(r.data, "itens") || [];
      } finally {
        this.carregando = false;
      }
    },
    novaFonte() {
      this.fonte = {
        id: 0,
        nome: "",
        tipo: "",
        modoSincronizacao: "MANUAL",
        ativo: true,
      };
      this.modalFonte = true;
    },
    novaFonteTipo(tipo) {
      this.fonte = {
        id: 0,
        nome: tipo === "FAQ" ? "Perguntas frequentes" : tipo === "ARQUIVO" ? "Documentos do agente" : "API de conhecimento",
        tipo,
        modoSincronizacao: tipo === "API" ? "MANUAL" : "EVENTO",
        ativo: true,
      };
      this.modalFonte = true;
    },
    editarFonte(f) {
      this.fonte = this.normal(f);
      this.modalFonte = true;
    },
    async salvarFonte() {
      let novaId = null;
      if (this.fonte.id)
        await axios.put(
          `/Process/AdminAgentes/Conhecimento/Agentes/${this.agenteId}/Fontes/${this.fonte.id}`,
          this.fonte
        );
      else {
        const resposta = await axios.post(
          `/Process/AdminAgentes/Conhecimento/Agentes/${this.agenteId}/Fontes`,
          this.fonte
        );
        novaId = this.val(resposta.data, "id");
      }
      this.modalFonte = false;
      await this.carregar();
      if (novaId) {
        const criada = this.fontes.find((x) => this.val(x, "id") === novaId);
        if (criada) this.abrirFonte(criada);
      }
    },
    async alternarFonte(f) {
      await axios.put(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          f,
          "id"
        )}/Ativo/${!this.val(f, "ativo")}`
      );
      await this.carregar();
    },
    async sincronizar(f) {
      await axios.post(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          f,
          "id"
        )}/Sincronizar`
      );
      await this.carregar();
    },
    abrirFonte(f) {
      this.selecionada = f;
      this.aba = "conteudo";
      this.carregarConteudo();
    },
    fecharFonte() {
      this.selecionada = null;
      this.carregar();
    },
    carregarConteudo() {
      const t = this.val(this.selecionada, "tipo");
      if (t === "FAQ") this.carregarFaqs();
      else if (t === "ARQUIVO") this.carregarArquivos();
      else this.carregarApi();
    },
    async carregarHistorico() {
      const r = await axios.get(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          this.selecionada,
          "id"
        )}/Sincronizacoes?pagina=1&tamanhoPagina=50`
      );
      this.historico = this.val(r.data, "itens") || [];
    },
    async carregarFaqs() {
      const q = new URLSearchParams({ pagina: 1, tamanhoPagina: 100 });
      if (this.buscaItem) q.set("busca", this.buscaItem);
      const r = await axios.get(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          this.selecionada,
          "id"
        )}/Faqs?${q}`
      );
      this.faqs = this.val(r.data, "itens") || [];
      this.selecionados = [];
    },
    novaFaq() {
      if (this.fonteInativa) return;
      this.faq = { id: 0, pergunta: "", resposta: "", acaoRecomendada: "NENHUMA", ativo: true };
      this.modalFaq = true;
    },
    editarFaq(q) {
      this.faq = this.normal(q);
      this.modalFaq = true;
    },
    async salvarFaq() {
      if (this.fonteInativa) return;
      const base = `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
        this.selecionada,
        "id"
      )}/Faqs`;
      if (this.faq.id) await axios.put(`${base}/${this.faq.id}`, this.faq);
      else await axios.post(base, this.faq);
      this.modalFaq = false;
      await this.carregarFaqs();
      await this.carregar();
    },
    async faqLote(reindexar) {
      if (this.fonteInativa) return;
      await axios.post(
        `/Process/AdminAgentes/Conhecimento/Faqs/Lote?reindexar=${reindexar}`,
        { ids: this.selecionados }
      );
      await this.carregarFaqs();
    },
    async desativarFaqsSelecionadas() {
      if (this.fonteInativa) return;
      if (!this.selecionados.length) return;
      if (!window.confirm("Desativar as FAQs selecionadas e remover seus vetores?")) return;
      await axios.post(
        "/Process/AdminAgentes/Conhecimento/Faqs/Lote?reindexar=false",
        { ids: this.selecionados, ativo: false }
      );
      await this.carregarFaqs();
      await this.carregar();
    },
    async alternarFaq(q) {
      if (this.fonteInativa) return;
      const ativo = !!this.val(q, "ativo");
      if (ativo && !window.confirm("Desativar esta FAQ e solicitar a remoção dos vetores?")) return;
      await axios.post(
        "/Process/AdminAgentes/Conhecimento/Faqs/Lote?reindexar=false",
        { ids: [this.val(q, "id")], ativo: !ativo }
      );
      await this.carregarFaqs();
      await this.carregar();
    },
    async carregarArquivos() {
      const r = await axios.get(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          this.selecionada,
          "id"
        )}/Arquivos?pagina=1&tamanhoPagina=100&ativo=true`
      );
      this.arquivos = this.val(r.data, "itens") || [];
    },
    async upload(e) {
      if (this.fonteInativa) return;
      const f = e.target.files[0];
      if (!f) return;
      const d = new FormData();
      d.append("arquivo", f);
      await axios.post(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          this.selecionada,
          "id"
        )}/Arquivos`,
        d
      );
      e.target.value = "";
      await this.carregarArquivos();
      await this.carregar();
    },
    async reprocessar(a) {
      if (this.fonteInativa) return;
      await axios.post(
        `/Process/AdminAgentes/Conhecimento/Arquivos/${this.val(
          a,
          "id"
        )}/Reprocessar`
      );
      await this.carregarArquivos();
    },
    abrirErroArquivo(a) {
      this.arquivoComErro = a;
      this.modalErroArquivo = true;
    },
    async reprocessarErroArquivo() {
      if (!this.arquivoComErro || this.fonteInativa) return;
      await this.reprocessar(this.arquivoComErro);
      this.modalErroArquivo = false;
      this.arquivoComErro = null;
    },
    async excluirArquivo(a) {
      if (this.fonteInativa) return;
      const nome = this.val(a, "titulo") || this.val(a, "nomeOriginal") || "este documento";
      if (!window.confirm(`Excluir ${nome} desta fonte e remover seus vetores?`)) return;
      await axios.delete(
        `/Process/AdminAgentes/Conhecimento/Arquivos/${this.val(a, "id")}`
      );
      await this.carregarArquivos();
      await this.carregar();
    },
    async abrirBiblioteca() {
      if (this.fonteInativa) return;
      this.modalBiblioteca = true;
      await this.carregarBiblioteca();
    },
    async carregarBiblioteca() {
      const q = new URLSearchParams({ pagina: 1, tamanhoPagina: 100 });
      if (this.buscaBiblioteca) q.set("busca", this.buscaBiblioteca);
      const r = await axios.get(
        `/Process/AdminAgentes/Conhecimento/Biblioteca?${q}`
      );
      this.biblioteca = this.val(r.data, "itens") || [];
    },
    async vincular(a) {
      if (this.fonteInativa) return;
      await axios.post(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          this.selecionada,
          "id"
        )}/Arquivos/Vincular`,
        { arquivoId: this.val(a, "id"), titulo: this.val(a, "nomeOriginal") }
      );
      this.modalBiblioteca = false;
      await this.carregarArquivos();
      await this.carregar();
    },
    async carregarApi() {
      const r = await axios.get(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          this.selecionada,
          "id"
        )}/Api`
      );
      this.api = r.data ? this.normal(r.data) : { metodo: "GET", ativo: true };
      if (this.api.id) {
        const i = await axios.get(
          `/Process/AdminAgentes/Conhecimento/Apis/${this.api.id}/Itens?pagina=1&tamanhoPagina=50`
        );
        this.apiItens = this.val(i.data, "itens") || [];
      }
    },
    async salvarApi() {
      if (this.fonteInativa) return;
      const r = await axios.put(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(
          this.selecionada,
          "id"
        )}/Api`,
        this.api
      );
      this.api.id = this.val(r.data, "id");
      await this.carregarApi();
    },
    async excluirFonteApi() {
      const nome = this.val(this.selecionada, "nome") || "esta API";
      if (!window.confirm(`Excluir fisicamente a fonte ${nome}? Esta ação não poderá ser desfeita e os vetores serão removidos.`)) return;
      await axios.delete(
        `/Process/AdminAgentes/Conhecimento/Fontes/${this.val(this.selecionada, "id")}`
      );
      this.api = { metodo: "GET", tipoAutenticacao: "NENHUMA", ativo: true };
      this.apiItens = [];
      this.fecharFonte();
    },
    async testarApi() {
      if (this.fonteInativa) return;
      const r = await axios.post(
        `/Process/AdminAgentes/Conhecimento/Apis/${this.api.id}/Testar`
      );
      this.testeApi = r.data;
    },
    normal(o) {
      return Object.fromEntries(
        Object.keys(o || {}).map((k) => [k[0].toLowerCase() + k.slice(1), o[k]])
      );
    },
    icone(t) {
      return t === "FAQ"
        ? "mdi mdi-comment-question-outline"
        : t === "ARQUIVO"
        ? "mdi mdi-file-multiple-outline"
        : "mdi mdi-api";
    },
    statusLabel(s) {
      return (
        {
          PENDENTE: "Pendente",
          PROCESSANDO: "Processando",
          INDEXADA: "Indexada",
          INDEXADO: "Indexado",
          ERRO: "Erro",
          DESATIVADA: "Desativada",
          CONCLUIDA: "Concluída",
          CONCLUIDA_COM_ERROS: "Concluída com erros",
          CANCELADA: "Cancelada",
          EXTRAINDO: "Extraindo",
          REMOVIDO: "Removido",
        }[s] ||
        s ||
        "—"
      );
    },
    modoLabel(s) {
      return (
        { MANUAL: "Manual", EVENTO: "Ao alterar" }[s] || s
      );
    },
    tipoSync(s) {
      return (
        {
          CARGA_INICIAL: "Carga inicial",
          INCREMENTAL: "Atualização incremental",
          REPROCESSAMENTO: "Reprocessamento",
          EXCLUSAO: "Exclusão",
        }[s] || s
      );
    },
    data(x) {
      return x
        ? new Date(x).toLocaleString("pt-BR", {
            dateStyle: "short",
            timeStyle: "short",
          })
        : "Nunca sincronizada";
    },
    tamanho(x) {
      const n = Number(x || 0);
      return n > 1048576
        ? (n / 1048576).toFixed(1) + " MB"
        : Math.ceil(n / 1024) + " KB";
    },
  },
};
</script>

<style scoped>
.kb-page {
  min-height: 100vh;
  background: #f3f6f8;
  color: #172331;
  padding: 28px 32px 60px;
  font-family: Inter, Arial, sans-serif;
  line-height: 1.45;
}
.kb-hero {
  background: linear-gradient(125deg, #172b3a, #286665);
  color: white;
  border-radius: 15px;
  padding: 28px 30px;
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.kb-hero span,
.detail-title span {
  display: block;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #9bd2cd;
}
.kb-hero h1 {
  color: #fff;
  font-size: 32px;
  margin: 6px 0;
}
.kb-hero p {
  margin: 0;
  color: #fff;
}
.hero-add { border:1px solid #ffffff55; background:#ffffff18; color:#fff; border-radius:8px; padding:11px 16px; cursor:pointer; font-weight:700 }
.help-strip { display:flex; gap:12px; align-items:flex-start; background:#eef7f6; border:1px solid #d3e7e4; border-radius:12px; padding:14px 17px; margin:16px 0; color:#355c5a }
.help-strip > i { font-size:22px; color:#2f7774 }
.help-strip p { margin:3px 0 0; color:#607775 }
.inactive-warning { display:flex; align-items:center; gap:9px; margin:16px 0 0; padding:12px 14px; border:1px solid #e8c590; border-radius:10px; background:#fff7e8; color:#825b21 }
.inactive-warning i { font-size:20px }
.back {
  border: 0;
  background: transparent;
  color: inherit;
  padding: 0;
  margin-bottom: 18px;
  cursor: pointer;
}
.primary {
  background: #2f7774 !important;
  color: white !important;
  border-color: #2f7774 !important;
}
.metrics {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin: 16px 0;
}
.metrics article {
  background: white;
  border-radius: 12px;
  padding: 17px;
  border: 1px solid #dee7ec;
}
.metrics small {
  display: block;
  color: #718096;
}
.metrics b {
  display: block;
  font-size: 25px;
  margin-top: 5px;
}
.metrics .warn b {
  color: #b77b20;
}
.metrics .danger b {
  color: #c54848;
}
.source-area,
.detail-area,
.panel {
  background: white;
  border: 1px solid #e4ecef;
  border-radius: 18px;
  padding: 24px;
}
.source-area h2, .source-area h3, .detail-area h2, .detail-area h3 { line-height:1.25 }
.toolbar,
.panel-head,
.detail-title {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
}
.toolbar h2,
.detail-title h2,
.panel h3 {
  margin: 0;
}
.toolbar p,
.detail-title p,
.panel-head p {
  margin: 4px 0;
  color: #77878d;
}
.toolbar input,
.toolbar select,
.filters input {
  padding: 10px 12px;
  border: 1px solid #d7e1e4;
  border-radius: 9px;
  margin-left: 8px;
}
.source-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 22px;
}
.source-card {
  border: 1px solid #e1e9eb;
  border-radius: 16px;
  padding: 20px;
  transition: 0.2s;
}
.source-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px #153e4514;
}
.source-head {
  display: flex;
  justify-content: space-between;
}
.source-head > i {
  font-size: 30px;
  color: #28756f;
}
.source-card small {
  display: block;
  margin: 14px 0 4px;
  color: #809096;
}
.source-card h3 {
  margin: 0 0 7px;
}
.source-card > p {
  height: 42px;
  color: #6f7e84;
  overflow: hidden;
}
.source-info {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #edf1f2;
  padding: 13px 0;
  color: #718188;
}
.source-card footer {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.source-card button,
.panel button,
.primary,
.toolbar button,
.detail-title button {
  border: 1px solid #d7e2e4;
  background: white;
  border-radius: 8px;
  padding: 9px 12px;
  cursor: pointer;
}
.pill {
  font-size: 11px;
  padding: 5px 8px;
  border-radius: 20px;
  background: #e9eff1;
  color: #607077;
  white-space: nowrap;
}
.pill.indexada,
.pill.indexado,
.pill.concluida {
  background: #dff4e9;
  color: #26744e;
}
.pill.pendente {
  background: #fff1d9;
  color: #9b6414;
}
.pill.erro,
.pill.concluida_com_erros {
  background: #fde4e4;
  color: #a93636;
}
.pill.processando,
.pill.extraindo {
  background: #dfedfa;
  color: #276497;
}
.detail-title {
  background: #173e45;
  color: white;
  margin: -24px -24px 0;
  padding: 24px;
  border-radius: 18px 18px 0 0;
}
.detail-title .back {
  display: block;
  background: transparent !important;
  border: 0 !important;
  color: #fff !important;
  padding: 0 !important;
  text-align: left;
}
.detail-title h2 {
  color: #fff !important;
}
.tabs {
  display: flex;
  gap: 5px;
  border-bottom: 1px solid #e4eaec;
  margin: 20px 0;
}
.tabs button {
  border: 0;
  background: transparent;
  padding: 12px 18px;
}
.tabs button.active {
  color: #247069;
  border-bottom: 3px solid #247069;
}
.panel {
  border: 0;
  padding: 0;
}
.empty {
  text-align: center;
  padding: 65px 20px;
  color: #809096;
}
.empty h3 { margin:12px 0 6px }
.empty p { margin:0 0 18px }
.empty-add { border-radius:8px; padding:10px 14px; cursor:pointer }
.empty i {
  font-size: 48px;
}
.empty.small {
  padding: 35px;
}
.faq-list article,
.file-grid article,
.api-items article,
.library article {
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid #e4ebed;
  border-radius: 12px;
  padding: 15px;
  margin-top: 10px;
}
.faq-list article > div,
.file-grid article > div,
.api-items article > div,
.library article > div {
  flex: 1;
}
.faq-list h4,
.file-grid h4 {
  margin: 3px 0;
}
.faq-list p,
.file-grid p,
.api-items p,
.library p {
  margin: 3px 0;
  color: #6f7f85;
}
.faq-list em {
  font-size: 12px;
  color: #839197;
}
.file-grid > article > i,
.library > article > i {
  font-size: 30px;
  color: #2c7772;
}
.upload {
  display: inline-block;
  border-radius: 8px;
  padding: 10px 13px;
  cursor: pointer;
}
.upload input {
  display: none;
}
.filters {
  display: flex;
  gap: 8px;
  margin: 18px 0;
}
.filters input {
  flex: 1;
  margin: 0;
}
.filters button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}
button:disabled,
.upload.disabled {
  cursor: not-allowed !important;
  opacity: 0.48;
}
.secondary {
  background: #fff !important;
  border-color: #9db7bb !important;
  color: #245d62 !important;
}
.danger {
  background: #fff4f3 !important;
  border-color: #e4aaa5 !important;
  color: #a43d35 !important;
}
.success {
  background: #e9f6ef !important;
  border-color: #9dceb4 !important;
  color: #26704a !important;
}
.item-actions {
  display: flex;
  flex: 0 0 auto !important;
  gap: 7px;
}
.pill.removido,
.pill.desativada {
  background: #edf0f2;
  color: #59666c;
}
.api-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-top: 20px;
}
.api-form label,
.modal label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 13px;
  color: #687980;
}
.api-form input,
.api-form select,
.api-form textarea,
.modal input,
.modal select,
.modal textarea,
.library > input {
  border: 1px solid #d7e1e4;
  border-radius: 8px;
  padding: 10px;
  font: inherit;
}
.wide {
  grid-column: 1/-1;
}
.api-form details {
  border: 1px solid #e0e8ea;
  border-radius: 10px;
  padding: 13px;
}
.api-form details label {
  margin-top: 10px;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.test-result {
  margin-top: 15px;
  background: #f0f6f6;
  border-radius: 10px;
  padding: 15px;
}
.test-result pre {
  max-height: 180px;
  overflow: auto;
  white-space: pre-wrap;
}
.timeline article {
  display: flex;
  gap: 15px;
  padding: 14px;
  border-left: 2px solid #d8e4e5;
  margin-left: 8px;
}
.timeline article > i {
  width: 10px;
  height: 10px;
  background: #2b7772;
  border-radius: 50%;
  margin-left: -20px;
  margin-top: 5px;
}
.timeline article > div {
  flex: 1;
}
.timeline .pill {
  float: right;
}
.timeline p,
.timeline em {
  color: #74848a;
}
.modal {
  position: fixed;
  inset: 0;
  background: #102c32aa;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.modal form,
.library {
  width: min(720px, 95vw);
  max-height: 90vh;
  overflow: auto;
  background: white;
  border-radius: 18px;
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.modal header,
.modal footer,
.library header {
  grid-column: 1/-1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal header h2,
.library h2 {
  margin: 3px 0;
}
.modal header button,
.library header button {
  border: 0;
  background: transparent;
  font-size: 26px;
}
.modal footer {
  justify-content: flex-end;
  gap: 10px;
}
.error-detail-link {
  display: block;
  margin-top: 7px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #b33f3f;
  font-size: 12px;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
.error-dialog {
  width: min(620px, 100%);
  background: #fff;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.28);
}
.error-dialog > h3 {
  margin: 18px 0 10px;
  overflow-wrap: anywhere;
}
.error-dialog header small {
  color: #b33f3f;
  font-weight: 800;
  letter-spacing: 1px;
}
.error-message {
  border: 1px solid #f0b9b9;
  border-radius: 9px;
  padding: 14px;
  background: #fff3f3;
  color: #8f3030;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.error-dialog dl {
  display: flex;
  gap: 30px;
  margin: 16px 0;
}
.error-dialog dt {
  color: #718096;
  font-size: 12px;
}
.error-dialog dd {
  margin: 3px 0 0;
  font-weight: 700;
}
.error-guidance {
  color: #52606d;
}
.library {
  display: block;
}
.library > input {
  width: 100%;
  box-sizing: border-box;
  margin: 10px 0;
}
@media (max-width: 1100px) {
  .metrics {
    grid-template-columns: repeat(3, 1fr);
  }
  .source-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 700px) {
  .kb-page {
    padding: 12px;
  }
  .kb-hero,
  .toolbar,
  .panel-head,
  .detail-title {
    align-items: stretch;
    flex-direction: column;
  }
  .hero-add { align-self:flex-start }
  .metrics {
    grid-template-columns: repeat(2, 1fr);
  }
  .source-grid {
    grid-template-columns: 1fr;
  }
  .modal form,
  .api-form {
    grid-template-columns: 1fr;
  }
  .wide {
    grid-column: auto;
  }
  .faq-list article,
  .file-grid article {
    align-items: flex-start;
    flex-wrap: wrap;
  }
}
</style>
